<template>
    <div class="tree-view">
        <svg v-bind:width="settings.width" v-bind:height="settings.height">
           
            <defs>
                <linearGradient id="gradient1" gradientTransform="rotate(105)">
                <stop offset="-29%" stop-color="#3683FC" />
                <stop offset="260%" stop-color="#21355C" />
                </linearGradient>

                <linearGradient id="gradient2" gradientTransform="rotate(333.91)">
                <stop offset="-13%" stop-color="#3683FC" />
                <stop offset="112%" stop-color="#51FFEA" />
                </linearGradient>

                <linearGradient id="gradient3" gradientTransform="rotate(329)">
                <stop offset="-7.9%" stop-color="#002C55" />
                <stop offset="110%" stop-color="#B0CFFF" />
                </linearGradient>

                <linearGradient id="gradient4" gradientTransform="rotate(34)">
                <stop offset="-12.4%" stop-color="#707D8B" />
                <stop offset="112%" stop-color="#3683FC" />
                </linearGradient>

                <linearGradient id="gradient5" gradientTransform="rotate(328)">
                <stop offset="-7.86%" stop-color="#143B87" />
                <stop offset="110%" stop-color="#730067" />
                </linearGradient>

                <linearGradient id="gradient6">
                <stop offset="30%" stop-color="#fff" />
                <stop offset="50%" stop-color="#3683FC" />
                <!-- <stop offset="60%" stop-color="#002C55" /> -->
                <stop offset="70%" stop-color="#fff" />
                </linearGradient>
            </defs>
    
            <!-- define graphical elements explicitely here and use the template syntax to loop through collections and bind properties to those elements -->
            
            <!-- links -->
            <transition-group tag="g" name="line" >


                <line v-for="link in links" 
                      v-bind:key="link.id" 
                      v-bind:x1="`${link.x1}%`"
                      v-bind:y1="`${link.y1}%`" 
                      v-bind:x2="`${link.x2}%`" 
                      v-bind:y2="`${link.y2}%`" 
                      style="stroke-width:3; 
                            stroke-opacity: 0.7;"
                      class="ecosystemchart-link" 
                      stroke="url(#gradient6)"
                    />
                
            </transition-group>


            <!-- nodes --> 
            
            <transition-group tag="g" name="list" class="list">
                <g v-for="(node, index) in nodes" 
                    v-bind:key="node.id"
                    v-bind:style="node.style" 
                    v-on:click="select(index, node)"
                    :fill="node.background"
                    >

                    <!-- Circles for each node -->  

                    <circle v-bind:r="node.r"></circle>

                    <!-- Finally, text labels -->
                    
                    <foreignObject :x="`${node.textpos.x}%`" :y="`${node.textpos.y}%`" :width="node.style.width" :height="node.style.height" style="overflow:visible">
                      <p :style="node.textStyle" xmlns="http://www.w3.org/1999/xhtml"> {{ node.id }} </p>
                    </foreignObject>

                </g>
            </transition-group>
        </svg>

    </div>
</template>


<script>
import { hierarchy, tree, cluster } from 'd3-hierarchy'
import VueScrollReveal from 'vue-scroll-reveal'

export default {
    name: 'EcosystemChart',
    props: {
        hierarchy: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localHierarchy: this.hierarchy,
            localDescendants: this.nodes,
            // size: [1600, 700],
            localRoot: this.root,
            settings: {
                width: '100%',
                height: 800
            }
        }
    },
    mounted() {
        // VueScrollReveal().reveal('.list');
    },

    // Instead of enter, update, exit, we mainly use computed properties and instead of "d3.data()" we can use array.map to create objects that hold class names, styles, and other attributes

    computed: {

        root: function() {

            this.localRoot = hierarchy(this.localHierarchy)

            return this.localRoot
        },


        tree: function() {

            return cluster()
                    .size(this.size)
        },
        nodes: function() {
            
            if (this.root) {
                return this.root.descendants().map(function(d) {
                    // d.data.y = (d.depth * 190)

                    return {
                        id: d.data.value,
                        r: +d.data.size / 2,
                        className: "node" +
                            (d.children ? " node--internal" : " node--leaf"),
                        // text: d.id.substring(d.id.lastIndexOf(".") + 1),
                        // highlight: d.id.toLowerCase().indexOf(that.search.toLowerCase()) != -1 && that.search != "",
                        style: {
                            transform: "translate(" + d.data.x + "%," + d.data.y + "%)",
                            fill: d.data.background,
                            width: d.data.size,
                            height: d.data.size
                        },
                        textpos: {
                            x: 0,
                            y: 0
                        },
                        textStyle: {
                            fontSize: d.data.fontSize,
                            color: d.data.color,
                            lineHeight: 1.1,
                            width: d.data.size,
                            height: d.data.size,
                            margin: 0,
                            maxWidth: '80%',
                            position: 'absolute',
                            display: 'block',
                            top: '-27%',
                            left: '-36%',
                            textAlign: 'center'
                        },
                        // textWrapperStyle: {
                        //     width: d.data.size,
                        //     height: d.data.size
                        // }
                    };
                });
            }
        },
        
        
        links: function() {
            
            if (this.root) {
                return this.root.links().map(function(d) {
                    let { value, y, x } = d.source.data
                    let yt = d.target.data.y
                    let xt = d.target.data.x
                    
                    return {
                        id: value,
                        x1: x, 
                        y1: y, 
                        x2: xt, 
                        y2: yt 
                    };
                });
            }
            
        }

    },

    watch: {

    },

    methods: {
       
    }
}
</script>


<style scoped lang="scss">

@import '../colors.scss';
@import '../mixins.scss';

.tree-view {
    position: relative;
    overflow: hidden;
    padding: 40px 0;
    > * {
        transition: all 600ms cubic-bezier(0.39, -0.29, 0.24, 1.19);
    }

    @include mobile {
        min-width: 1600px;
        overflow-x: auto;
        padding: 0;
    }
}
.text-wrapper {
    width: 150px;
    height: 150px;
}

.ecosystemchart-link {
    position: relative;

    &:before {
        content: '';
        display: block;
        width: 100px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
    }
}

.list {
    opacity: 1;
}

.list-enter {
    opacity: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>